module.exports = __webpack_public_path__ + "static/media/nav-icon-accounts.72f8cbae.svg";